export const commonUi = {
	state: {
		/** header Layout Type */
		headerType: 'A',
		/** Footer Layout Type */
		footerType: 'A',
		/** 페이지 타이틀 */
		title: '',
		/** 헤더 타이틀 스택
		 * @example
		 * [{ key: string, title: string }]
		 */
		headerTitleStack: [],
		/** Quick 사용여부 */
		quick: false,
		/** full 메뉴 오픈 관련 */
		menuOpened: false,
		/** 하단 고정 버튼 노출 상태 */
		hasFixedButtons: false,
		/** 로딩중인 API 수 */
		loadingCount: 0,
	},

	mutations: {
		'COMMON_UI/SET_LAYOUT'(state, payload) {
			state.headerLayout = payload.headerLayout ?? state.headerLayout;
			state.footerLayout = payload.footerLayout ?? state.footerLayout;
			state.title = payload.title ?? state.title;
			state.headerType = payload.headerType ?? state.headerType;
			state.footerType = payload.footerType ?? state.footerType;
			state.quick = payload.quick ?? state.quick;
			state.menuOpen = payload.menuOpen ?? state.menuOpen;
		},
		'COMMON_UI/SET_MENU_OPENED'(state, payload) {
			state.menuOpened = payload;
		},
		'COMMON_UI/ADD_HEADER_TITLE'(state, { key, title }) {
			state.headerTitleStack = [...state.headerTitleStack, { key, title }];
		},
		'COMMON_UI/UPDATE_HEADER_TITLE'(state, { key, title }) {
			state.headerTitleStack = state.headerTitleStack.map(item => {
				if (item.key === key) return { key, title };
				return item;
			});
		},
		'COMMON_UI/REMOVE_HEADER_TITLE'(state, { key }) {
			state.headerTitleStack = state.headerTitleStack.filter(item => item.key !== key);
		},
		'COMMON_UI/SET_HAS_FIXED_BUTTONS': (state, hasFixedButtons) => {
			state.hasFixedButtons = hasFixedButtons;
		},
		'COMMON_UI/SET_LOADING_COUNT': (state, count) => {
			state.loadingCount = count < 0 ? 0 : count;
		},
	},

	actions: {
		addHeaderTitle({ commit }, { key, title }) {
			commit('COMMON_UI/ADD_HEADER_TITLE', { key, title });
		},
		updateHeaderTitle({ commit }, { key, title }) {
			commit('COMMON_UI/UPDATE_HEADER_TITLE', { key, title });
		},
		removeHeaderTitle({ commit }, { key }) {
			commit('COMMON_UI/REMOVE_HEADER_TITLE', { key });
		},
		setLayout({ commit }, payload) {
			commit('COMMON_UI/SET_LAYOUT', payload);
		},
		openMenu({ commit }) {
			commit('COMMON_UI/SET_MENU_OPENED', true);
		},
		closeMenu({ commit }) {
			commit('COMMON_UI/SET_MENU_OPENED', false);
		},
		toggleMenu({ commit, state }) {
			commit('COMMON_UI/SET_MENU_OPENED', !state.menuOpened);
		},
		loadingStart({ commit, state }) {
			commit('COMMON_UI/SET_LOADING_COUNT', state.loadingCount + 1);
		},
		loadingComplete({ commit, state }) {
			commit('COMMON_UI/SET_LOADING_COUNT', state.loadingCount - 1);
		},
		setHasFixedButtons({ commit }, payload) {
			commit('COMMON_UI/SET_HAS_FIXED_BUTTONS', payload);
		},
	},

	getters: {
		showsHeader: state => state.headerType !== 'None',
		headerType: state => state.headerType,
		showsFooter: state => state.footerType !== 'None',
		footerType: state => state.footerType,
		showsMenu: state => state.menuOpened,
		showsQuickNavigator: state => state.quick,
		headerTitle: state => state.headerTitleStack?.[state.headerTitleStack.length - 1]?.title,
		pending: state => Boolean(state.loadingCount),
		hasFixedButtons: state => state.hasFixedButtons,
	},
};

export default commonUi;
